<template>
  <div class="home">
    <van-nav-bar
      :title="$t('ShopList.RechargeAmountSetting')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <div class="addRechargeAmount-main">
      <van-field
        v-model="List.name"
        :name="$t('member.name')"
        :label="$t('member.name')"
        :placeholder="$t('member.nameplaceholder')"
      />
      <van-field
        v-model="List.price"
        :name="$t('member.PaymentAmount')"
        :label="$t('member.PaymentAmount')"
        :placeholder="$t('member.PaymentAmountplaceholder')"
      />
      <van-field
        v-model="List.amount"
        :name="$t('member.RechargeAmount')"
        :label="$t('member.RechargeAmount')"
        :placeholder="$t('member.RechargeAmountplaceholder')"
      />
      <van-field
        v-model="List.discount"
        :name="$t('member.Discount')"
        :label="$t('member.Discount')"
        :placeholder="$t('member.Discountplaceholder')"
      />
      <van-cell>
        <template #title>
          <div class="status_switch">
            <span class="status_title">{{ $t("member.Switch") }}</span>
            <van-switch v-model="List.status" size="20" />
          </div>
        </template>
      </van-cell>
      <van-field
        v-model="List.order_number"
        :name="$t('member.order_number')"
        :label="$t('member.order_number')"
        :placeholder="$t('member.order_numberPlaceholder')"
      />
      <div class="footer">
        <van-button round type="info" @click="okBtn">
          {{ $t("ShopStatus.certain") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actShopId: "",
      List: {
        name: "",
        price: "",
        amount: "",
        discount: "",
        status: true,
        order_number: ""
      }
    };
  },
  mounted: function() {
    this.actShopId = sessionStorage.getItem("actShopId");
    if (this.$route.query.list) {
      this.type = "update";
      this.List = JSON.parse(this.$route.query.list);
      this.List.status = this.List.status == 0 ? false : true;
    }
  },
  methods: {
    okBtn() {
      if (this.type == "update") {
        this.patchRecharge();
      } else {
        this.recharge();
      }
    },
    // 添加充值金額內容
    recharge() {
      let data = JSON.parse(JSON.stringify(this.List));
      data.store_id = this.actShopId;
      data.status = data.status ? 1 : 0;
      console.log(data);
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/recharge/store",
        data: data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$router.go(-1);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 修改充值金额内容
    patchRecharge() {
      let data = JSON.parse(JSON.stringify(this.List));
      data.store_id = this.actShopId;
      data.status = data.status ? 1 : 0;
      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/recharge/${this.List.id}/update`,
        data: {
          name: data.name,
          price: data.price,
          amount: data.amount,
          discount: data.discount,
          status: data.status,
          order_number: data.order_number
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$router.go(-1);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-button {
  height: 2.1875rem;
}
.status_title {
  width: 6.2em;
  margin-right: 12px;
}
.status_switch {
  display: flex;
  align-items: center;
}
.footer {
  text-align: center;
  margin: 10px;
}
.footer .van-button {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/Shop/addRechargeAmount.vue